// @flow
import React from 'react';

import notification from 'antd/lib/notification';

import { driverInspectionApi } from '../../../../../lib/api';
import type { DriverInspection } from '../../../../../lib/types';

import Filter from '../../../../services/pass/Filter';
import { DRIVER_INSPECTION_COLUMNS } from '../../../../services/driverInspections';

import { ListTable } from '../../../lib';

export default class extends ListTable<DriverInspection> {
  fetch = async (page: number = 1) => {
    const params = super.fetch(page);
    try {
      const data = await driverInspectionApi.fetchDriverInspections(params);
      const totalSum = await driverInspectionApi.getTotalSum(params);
      this.setState({ ...data, totalSum, loading: false, page });
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  };

  render() {
    return (
      <>
        {super.renderFilter(Filter)}
        {super.renderTable(DRIVER_INSPECTION_COLUMNS)}
      </>
    );
  }
}
